import React, { useMemo } from 'react';
import Box from 'components/elements/Box';
import { ReactComponent as TopListsIcon } from 'icons/fire-icon-header.svg';

import { useTopicFilters } from './utils/useTopicFilters';
import { AllTopicTypes } from 'topics';
import { filtersForTopic } from './shared';
import {
  LogoFlexWrapper,
  TopicSection,
  TopicTitle,
  FilterTitle,
} from './TopicFilters.styles';
import { EntityTypes } from 'context/entityContext';
import Layout from 'components/styled/Layout/Layout';
import useFilterList from './utils/useFilterList';
import CountryFlag from 'components/base/CountryFlag';
import CustomerIcon from 'components/base/CustomerIcon/CustomerIcon';

import useMedia from 'hooks/useMedia';

interface ITopicFiltersStickyTopBarProps {
  topic?: AllTopicTypes[];
  entityType?: EntityTypes | string;
}

const TopicFiltersStickyTopBar: React.FC<ITopicFiltersStickyTopBarProps> = (
  props
) => {
  const { topic, entityType } = props;

  const activeTopic =
    topic && topic.length ? (topic[1] ? topic[1] : topic[0]) : 'home';

  const [filters] = useTopicFilters();

  const validFilters = useMemo(() => {
    return activeTopic ? filtersForTopic[activeTopic] || [] : [];
  }, [activeTopic]);

  const topicFilterList = useFilterList(filters, validFilters);
  const isSmallScreen = useMedia('(max-width: 50em)');

  const getLogo = (logoType: string): any => {
    if (logoType === 'topLists') {
      return (
        <LogoFlexWrapper>
          <TopListsIcon width={27} height={27} />
        </LogoFlexWrapper>
      );
    }
    if (logoType === 'country') {
      const country = topicFilterList[logoType];
      return (
        <LogoFlexWrapper>
          <CountryFlag
            small
            id={country.id ?? 'WW'}
            displayName={country.displayName}
            flagImgSmall={country.flagImgSmall}
            flagImgMedium={country.flagImgMedium}
            flagImgLarge={country.flagImgLarge}
          />
        </LogoFlexWrapper>
      );
    }
    if (logoType === 'streaming') {
      const customerName = topicFilterList[logoType]?.name;
      return (
        <LogoFlexWrapper>
          {customerName && <CustomerIcon aria-hidden customer={customerName} />}
        </LogoFlexWrapper>
      );
    }

    return null;
  };
  const isTopLists = activeTopic === 'topLists';
  const topicTitle = isTopLists ? 'WHAT’S \nTRENDING' : entityType;

  return (
    <Layout.MaxWidth topList={activeTopic === 'topLists'}>
      <Box display="flex" flexDirection="row" alignItems="center">
        {((activeTopic !== 'topLists' && !isSmallScreen) ||
          (activeTopic === 'topLists' && !isSmallScreen)) && (
          <TopicSection topList={activeTopic === 'topLists'}>
            {getLogo(activeTopic)}
            <TopicTitle>{topicTitle}</TopicTitle>
          </TopicSection>
        )}
        {validFilters.map(
          (filter: string): JSX.Element => (
            <TopicSection
              key={`filter-${filter}`}
              isSmallScreen={isSmallScreen}
              isTopLists={isTopLists}
              topList={activeTopic === 'topLists'}
            >
              {getLogo(filter)}
              <FilterTitle>{topicFilterList[filter]?.displayName}</FilterTitle>
            </TopicSection>
          )
        )}
      </Box>
    </Layout.MaxWidth>
  );
};

export default TopicFiltersStickyTopBar;
